import React from 'react'
import classes from './home.module.css'
import { Avatar, Flex, Space } from 'antd'
function WebIntro() {
    return (
        <>
            <div 
                className={classes.mainHeaderLogo}                
            >
                <div>BNS 伯纳思</div>
            </div>
            <div style={{padding:'20px',fontSize:"16px"}}>
                &emsp;&emsp;湖北伯纳思网络科技有限公司始建于2002年，前身是宜昌福星计算机网络有限公司，1998年改名为宜昌乐达网络有限公司，2017年重组成立湖北伯纳思网络科技有限公司，是湖北省软件优秀企业，为政府和企业系统开发、定制开发业务。
            </div>
            <Flex justify='center'>
                <Space size={50}>
                    <Avatar
                        src='./img/home/intro1.png'
                        shape="square"
                        size={150}
                    />
                    <Avatar
                        src='./img/home/intro2.png'
                        shape="square"
                        size={150}
                    />
                </Space>
            </Flex>
            <div style={{padding:'20px',fontSize:"16px"}}>
                &emsp;&emsp;近年来，伯纳思聚焦主业、有进有退、同心多元，依托国家科技创新、独立自主的大好政策，优化升级信息产业，构建适合政府和企业的信息系统，为广大客户提供技术服务，获得了客户的一致好评和良好的口碑效应。
            </div>
            <div style={{padding:'20px',fontSize:"16px"}}>
                &emsp;&emsp;未来，伯纳思将聚焦政府和企业的系统软件，让政府和企业插上信息技术的翅膀，形成“网络、数据、智能”全要素信息化体系，成为系统软件产业主导者、为推动中国信息现代化、助力经济腾飞贡献更大力量。
            </div>
            <div style={{padding:'20px',fontSize:"16px"}}>
                &emsp;&emsp;湖北三峡数据中心作为国家“东数西算”工程的重要节点和长江经济带数字基础设施的核心载体，正以创新技术、绿色理念和战略布局重塑华中地区的数据产业生态。这一由三峡集团牵头建设的数字基建集群，包含东岳庙数据中心、中国电信（三峡·宜昌）大数据基地等多个标杆项目，不仅承载着区域数字化转型的使命，更通过清洁能源与数字技术的深度融合，探索出具有示范意义的可持续发展路径。<br/>                           
                &emsp;&emsp;湖北伯纳思网络科技有限公司依托三峡数据中心的优势资源，精心打造'旅当家'品牌企业管理软件，助力企业实现数字化转型，为实现企业管理现代化做出贡献。<br/>
            </div>
        </>
    )
}

export default WebIntro